
define('application',['jquery',
	'eteration/eteration-i18n',
	'eteration/eteration-ajax',
	'jquery.placeholder',
	'bootstrap.select',
	'jquery.bgLoaded'],
function($,i18n,etrAjax){
	
	var browser = {
			isIE : navigator.userAgent.match(/MSIE ([0-9]+)\./) ? true : false,
			version : RegExp.$1
	}
	if (!Object.entries) {//es6 entries - for ie
		Object.entries = function( obj ){
			var ownProps = Object.keys( obj ),
				i = ownProps.length,
				resArray = new Array(i); // preallocate the Array
			while (i--)
				resArray[i] = [ownProps[i], obj[ownProps[i]]];
			return resArray;
		}
	}
	
	if (!String.includes) {//es6 includes - for ie
		String.prototype.includes = function (str) {
		  var returnValue = false;

		  if (this.indexOf(str) !== -1) {
		    returnValue = true;
		  }

		  return returnValue;
		}
	}
	
	if (!Array.isArray) {
		  Array.isArray = function(arg) {
		    return Object.prototype.toString.call(arg) === '[object Array]';
		  };
	}
	
	window.mobileSize = false;
	window.findBootstrapEnvironment = function(){
		var envs = ['xs', 'sm', 'md', 'lg'];
		var $el = $('<div>');
		$el.appendTo($('body'));
		for (var i = envs.length - 1; i >= 0; i--) {
			var env = envs[i];
			$el.addClass('hidden-'+env);
			if ($el.is(':hidden')) {
				$el.remove();
				return env
			}
		}
	};	

    window.enableButton = function (elem) {
    	if(!elem)
    		elem = '.onclickdisable';
        $(elem).removeClass('disabled');
    };

    window.disableButton = function (elem) {
    	if(!elem)
    		elem = '.onclickdisable';
        $(elem).addClass('disabled');
    };
	
	window.paymentTypes = ['ideal','sofort','bkmExpress','unionPay','samanBank','payPal','klarna','knet', 'sadad', 'boleto', 'qiwi', 'alipay'];
	
	window.sessionData = null;
	try {
		window.sessionData = window.sessionStorage;
	} catch (e) {

	}
	
	window.toCDNPATH = function(url) {
		if(window.cdnDomain){
			url = window.cdnDomain+ url;
		}
		return url;
	};
	
	window.isScrolledIntoView = function(elem){
	    var $elem = $(elem);
	    var $window = $(window);

	    var docViewTop = $window.scrollTop();
	    var docViewBottom = docViewTop + $window.height();
	    var elemTop = $elem.offset().top;

	    return  ((docViewTop < elemTop) && (docViewBottom > elemTop)); 
	};

	function getHeaderTHYLogo() {
		var cdnUrl = (window.cdnDomain)?window.cdnDomain:"";
		return '<div style="padding: 10px 15px; background-color:#E81932; -webkit-print-color-adjust:exact; float: left;">' +
					'<img src="' + cdnUrl +'/theme/img/logo-top-white.png"/>' +
					'<img src="' + cdnUrl +'/theme/img/logo-top-white-small.png" style="padding-left:5px"/>' +
				'</div>';
	}

	window.print = function(el, etrAjax){
		var basePath = window.location.host === 'localhost'? toCDNPATH('assets/js') : toCDNPATH('/com.thy.web.online.portal/assets/js')
		$.when(
				etrAjax ? etrAjax.startLoading():'',
			    $.getScript( basePath+"/jquery.printthis.js" ),
			    $.getScript( basePath+"/html2canvas.js" ),
			    $.getScript( basePath+"/canvas2image.js" ),
			    $.Deferred(function( deferred ){
			        $( deferred.resolve );
			    })
			).done(function(){

				var clonedNode = $('#' + el).parent().clone();
				var cloneWrapperId = el + '_cloneWrapper';
				$('body').append('<div id="' + cloneWrapperId +'" style="display:none;max-width:1024px;">'+ clonedNode.html() +'</div>');
				var cloneWrapper = $('#' + cloneWrapperId);
				var printArea = cloneWrapper.find('#' + el);
				cloneWrapper.show();
				
				var visibleprint = false;
				if (printArea.hasClass('visible-print')) {
					visibleprint = true;
					printArea.removeClass('visible-print');
				} 
				
				printArea.find('.hidden-print').remove();
				var printableTabs = printArea.find('.tab-pane').not('.active');
				printableTabs.addClass('printable-tab-content');
				printableTabs.addClass('mb-20');

				printArea.find('#contactEmail').val($("#contactEmail").val());
				printArea.find('#contactPhone').attr('type', 'text');// type="tel" somehow disappears in the PDF
				printArea.find('#contactPhone').val($("#contactPhone").val());
				
				$('#' + el).find('canvas').each( function() {
			        var image = new Image();
			        image.crossOrigin = "anonymous";
			        image.src = this.toDataURL("image/png");
			        image.width = $(this).width();
			        image.height = $(this).height();

			        cloneWrapper.find('#' + this.id).replaceWith(image);
			    });
				
				html2canvas(printArea, {
					useCORS: true,
					onrendered: function(canvas){
						$('body').append('<div id="'+el+'canvas" class="container printimage"></div>');
						var image = Canvas2Image.convertToImage(canvas,printArea.width(),printArea.height(),'png');
						var printCanvas = $('#'+el+'canvas');
						
						printCanvas.html(image);

						printCanvas.printThis({
							pageTitle: 'Turkish Airlines',
							importCSS: false,
							importStyle: true,
							printContainer: true,
							printDelay: browser.isIE == true ? 666 : 333,
							loadCSS: '/theme/css/theme.css',
							header: ""
						});
						
						if ( visibleprint ) {
							printArea.addClass('visible-print');
						}
						
						printCanvas.remove();
						cloneWrapper.remove();
						etrAjax ? etrAjax.stopLoading():'';
					},logging: true
				});

			}).fail(function(){
				etrAjax.stopLoading();
			});
	};

	window.charlimit = function(){
		$('.charlimit').each(function(){
			var ml = $(this).attr('data-limit');
			if ( $(this).text().length > ml ) {
				var tx = $(this).text().substr(0, ml);
				$(this).html(tx).append('...');
			}
		});
	};
	
	


	
	window.printall = function(el, pagesize){
		var count = [];
		
		var visibleprint = false;
		if ( $('#'+el).hasClass('visible-print') ) {
			visibleprint = true;
			$('#'+el).removeClass('visible-print');
		}
		
		$('body').append('<div id="'+el+'Canvas" class="container printimage"></div>');
		
		for ( var i = 1; i <= pagesize; i++ ) {
			(function(i){
				$('#'+el+'Canvas').append('<div id="'+el+'Canvas_'+i+'" style="page-break-after: always;"></div>');
				var parent = $('#'+el+'_'+i+'');
				
				html2canvas(parent, {
					onrendered: function(canvas){

						var i = count.pop();
						var image = Canvas2Image.convertToImage(canvas, parent.width(), parent.height(),'png');
						$('#'+el+'Canvas_'+i+'').html(image);
						count.splice(i);
					}
				});
				
				count.push(i);
			})(i);
		}
		
		$('#'+el+'Canvas').printThis({
			pageTitle: 'Turkish Airlines',
			importCSS: false,
			importStyle: true,
			printContainer: true,
			loadCSS: '/theme/css/theme.css',
			header: getHeaderTHYLogo()
		});
		
		setTimeout(function(){
			$('#'+el+'Canvas').remove();
			
			if ( visibleprint === true ) {
				$('#'+el).addClass('visible-print');
			}
		},1000);
	};

	window.carouselIndicators = function(container){
		container = container || '.carousel';

		$(container).each(function(){
			var self = $(this),
			items = self.find('.item'), 
			cid = $(this).attr('id'),
			indicators = self.find('.carousel-indicators');
			if(self.hasClass('stop-slide')){
				self.carousel('pause');
			}
			if(!indicators.length)
				indicators = $('<ol class="carousel-indicators"></ol>');
			if (!self.hasClass('no-indicators') && items.length > 1) {
				indicators.empty();
				for (var j = 0; j < items.length; j++) {
					var indic = $('<li/>', {
						'data-bs-slide-to' : j,
						'data-bs-target' : '#' + cid,
						'class' : j == 0 ? 'active' : ''
					});
					indicators.append(indic);
				}
				self.append(indicators);
			}
			items.removeClass('active').first().addClass('active')
			if ( items.length < 2 ) {
				self.find('.carousel-control').hide();
				indicators.empty().hide();
			} else {
				self.find('.carousel-control').show();
				indicators.show();
			}
			
			self.on('slid.bs.carousel', function () {
			    var $holder = self.find("li.active");
			    $holder.removeClass('active');
			    var idx = self.find('.item').index(self.find('div.active'));
			    self.find('ol.carousel-indicators li[data-bs-slide-to="'+ idx+'"]').addClass('active');
			});
			
			setFleetCarouselTitles(self);
			
			self.on('slid.bs.carousel', function () {
			    var $holder = self.find("li.active");
			    $holder.removeClass('active');
			    var activeItem = self.find('div.active');
			    var idx = self.find('.item').index(activeItem);
			    self.find('ol.carousel-indicators li[data-bs-slide-to="'+ idx+'"]').addClass('active');
			    setFleetCarouselTitles(self);
			});
		});
		
		$('ol.carousel-indicators  li').on('click',function(){ 
		    $('ol.carousel-indicators li.active').removeClass('active');
		    $(this).addClass("active");
		});
		
		initializeCarousel();
	};
	
	function setFleetCarouselTitles(carouselComponent){
		if(carouselComponent.hasClass('ourfleetcarousel')){
			var activeItem = carouselComponent.find('div.active');
		    var prevInfo = activeItem.find('.prev-info');
		    var prevInfoTitle = carouselComponent.find('.prev-arrow-title'); 
		    if(prevInfo.length > 0 && prevInfoTitle.length > 0){
		    	prevInfoTitle.text(prevInfo.text());
		    }
		    
		    var nextInfo = activeItem.find('.next-info');
		    var nextInfoTitle = carouselComponent.find('.next-arrow-title'); 
		    if(nextInfo.length > 0 && nextInfoTitle.length > 0){
		    	nextInfoTitle.text(nextInfo.text());
		    }
	    }
	}

	function initializeCarousel(){
		var counter = 0;
		var tryLoadCarousel = setInterval(
			function() {
				var carouselComp = $('.carousel');

				if(carouselComp && carouselComp.length > 0 && typeof carouselComp.carousel === 'function'){
					carouselComp.not('.wingo-carousel').carousel({
						interval: 8000,
						pause: 'hover'
					});

					bindCarouselFocus();
					clearInterval(tryLoadCarousel)
				}

				if(counter === 5){
					clearInterval(tryLoadCarousel)
				}
				counter++;
			},1000)
	}

	initializeCarousel();
	
	function bindCarouselFocus() {
		$('.carousel-control').focus(function() {
			$(this).parent().carousel('pause'); 
		});
		$('.carousel-control').focusout(function() {
			$(this).parent().carousel({
				pause:false
			}); 
		});
	}
	
	window.hashCode = function(s) { // do not declare this as a variable
		var hash = 0, i, chr, len;
		if (s.length == 0) return hash;
		for (i = 0, len = s.length; i < len; i++) {
			chr   = s.charCodeAt(i);
			hash  = ((hash << 5) - hash) + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	};
	
	function startBookerAnimation() {
		setTimeout(function(){
			$("#animated-text").addClass('customchain').addClass('opacity-1');
			$('.schedule-visibility-hidden').addClass('flipInX').removeClass('schedule-visibility-hidden');
		}, 500);
	}

	window.contentheight = function() {
		if($("#portableBookerManageTab").length == 0){
			var widthSize = $(window).width();
			if(widthSize >= 768){
				if ($('#mytripsMainPanelId').length != 0) {
					$('.middle-container').height("400").addClass('middle-wrapper');
				} else {
					$('.middle-container').height("659").addClass('middle-wrapper');
				}
			}
			var singleBg = $('.middle-wrapper .single-bg');
			singleBg.each(function(){
				var item = $(this);

				var parent;

				if ( item.parent('span').parent('span').length > 0 ) {
					parent = item.parent().parent().parent();
				} else if (item.parent('span').length > 0 ) {
					parent = item.parent().parent();
				} else {
					parent = item.parent();
				}

				if(item.parents('.section-bg').find('.background-image-mobile').length > 0){
					if(parent.attr('height-flag') == 'true'){
						parent.css({'height': item.find('.background-image-mobile').height()});
					}
				}else{
					if(!parent.hasClass('loading-bg') && parent.attr('height-flag') != 'true'){
						parent.attr({'height-flag': 'true'});
						item.attr({'height-flag': 'true'});
						parent.css({'height':  item.height()});
						item.css({'height':  item.height()});
					}

				}
				item.removeClass('single-bg-height');


			});
			$('.section-bg').each(function(){
				var item = $(this);
				var heroParents = item.parents('.hero');
				if (heroParents) {
					var dataUrl = item.attr('data-url');
					if(dataUrl){
						heroParents.css('background-image','url("'+ dataUrl +'")');
                        if($('#mytripsMainPanelId').length == 0){
                            heroParents.addClass('hero-bg');
                        }
						item.parents('.hero').bgLoaded({
							afterLoaded : function() {
								startBookerAnimation();
							}
						});

					}else {
						startBookerAnimation();
					}
				}else{
					startBookerAnimation();
				}
			});
			$('.cover').each(function(){
				var item = $(this);
				var sections = item.parents('section');
				if (sections) {
					var dataUrl = item.attr('data-url');
					if(dataUrl){
						sections.css('background-image','url("'+ dataUrl +'")').addClass('cover-bg');
					}
				}
			});

			// Check Mobile
			if ( findBootstrapEnvironment() === 'xs' ) {
				window.mobileSize = true;
			}
		}
	};
	
	function notResponsiveImgForMobile(item,bgImg,bgImgURL,heightOfMobileImg){
	    
        var stdContainer=item.find('.container.container-xs-height');
	    var cmsContainer=item.find('.container.cms-big-section');
        
        bgImg.addClass("visible-xs");
	    item.prepend('<div class="background-image-mobile" style="height:'+heightOfMobileImg+'px;" ></div>');
    	item.find('.background-image-mobile').css('background-image', 'url(' + bgImgURL + ')');
    	item.find('.textboxcolor-gray-overlay').css('background-color','rgba(121,136,154,.0)')
    	item.find('.carousel-caption').css('text-shadow','none');
    	item.find('.carousel-caption').addClass('black');
        if(cmsContainer.length>0){
             cmsContainer.addClass('black');
             cmsContainer.addClass('pt-5').addClass('pb-15');
             cmsContainer.find('b').replaceWith(function() {
        	    return '<h2 class="font-700 ls-0-5 grey fs-14 ">'+$(this).text()+'</h2>';
        	});
        	cmsContainer.find('h4').replaceWith(function() {
                return '<h3 class="" >' + $(this).text() + '</h3>';
            });
             if(cmsContainer.find('h3')){
            	 var h3element=cmsContainer.find('h3');
            	 h3element.addClass('mb-0');
            	 h3element.css('font-size','28px');
            	 h3element.css('font-family','MuseoSans-100');
            	 h3element.css('letter-spacing','-1.5px');
            	 h3element.css('line-height','normal');
             }
        }
        
    	if(stdContainer.length>0){
    	    stdContainer.removeAttr( "style" );
    	    setTimeout(function(){
    	        stdContainer.css('height','auto');
    	    },1000);
    	    stdContainer.find('h2').replaceWith(function() {
               return '<h2 class="font-700 ls-0-5 grey fs-14 text-left">'+$(this).text()+'</h2>';
            });
            stdContainer.find('.grid-bottom').addClass('text-left');
            stdContainer.find('.grid-bottom p').addClass('fs-14-mbl');
    	    stdContainer.addClass('pt-5').addClass('pb-15');
    	    item.find('.container .textboxcolor').removeClass('textboxcolor-black-overlay').addClass('mb-0').addClass('mt-0').addClass('pt-0').addClass('pb-0');
    	
    	}
        if(item.find('.white').length>0){
             item.find('.white').addClass('black').removeClass('white');
        }
        
        item.find('.img-section-bg').removeClass("visible-xs").addClass('clearer');
	    item.find('.item-left .carousel-caption').addClass('black');
	    item.find('.item-right .carousel-caption').addClass('black');
	    item.find('i').addClass('dark');
	}
	
	function correctImgSizeMobileOrWeb(item,bgImgURL){
	    item.css('background-image', 'url(' + bgImgURL + ')');
	}
	
	function sectionBg() {
	    setTimeout(function(){
			$('.section-bg').each(function() {
				var item = $(this);
				if(!item.attr('data-checked')){
	    		    item.attr('data-checked','true');
	    			var bgImg=item.find('.img-section-bg');
	    			var bgImgURL = bgImg.attr('src');
					if(!bgImgURL && bgImg && bgImg.context) {
						bgImgURL = bgImg.context.getAttribute("data-url");
					}
	    			var imgBgWidth;
	                var imgBgHeight;
	    			imgBgWidth=bgImg.prop('naturalWidth') ? bgImg.prop('naturalWidth'):item.width();
	                imgBgHeight=bgImg.prop('naturalHeight') ? bgImg.prop('naturalHeight'):item.height();
	                
	                if(!window.isPhoneOrTablet){
	        			if (bgImgURL) {
	        			    correctImgSizeMobileOrWeb(item,bgImgURL);
	        			}
	                }else if($('#destinationbookerinner').length == 0 && $('#insurance').length == 0 && $('#promotion').length == 0){
	                    if (bgImgURL && imgBgWidth && imgBgHeight &&((imgBgWidth/imgBgHeight)>=1.0) ) {
	                        var imgRate=(imgBgWidth/ screen.width);
	                       imgRate= imgRate-0.3;
	                        var imgHeight=imgBgHeight/imgRate;
	                       
	                        notResponsiveImgForMobile(item,bgImg,bgImgURL,imgHeight);
	        				
	        			}else{
	        			   correctImgSizeMobileOrWeb(item,bgImgURL);
	        			}
	                }else{
	                    correctImgSizeMobileOrWeb(item,bgImgURL);
	                }
	                item.find('.img-section-bg').css('visibility', 'hidden');
			    }
			});
	    },500);
	}
	
	window.readmore = function(rmtext,rltext,rmc,el){
		if ( $(el).parent().hasClass('readmore') ){
			$(rmc).removeClass('readmore');
			setTimeout(function(){$(el).text(rmtext);},250);
		} else {
			$(rmc).addClass('readmore');
			$(el).text(rltext);
		}
		
		if ( $('.container').hasClass('article-up') ) {
			if ( $(el).parent().hasClass('readmore') ){
				$(rmc).parent().attr('data-style',$(rmc).parent().attr('style'));
				$(rmc).parent().removeAttr('style');
			} else {
				setTimeout(function(){
					$(rmc).parent().attr('style',$(rmc).parent().attr('data-style'));
					$(rmc).parent().removeAttr('data-style');
				},250);
			}
		}
	};
	
	
	window.article = function (el){
		if ( !$(el).attr('class') ) {
			$(el).each(function(i){
				var rmtext = $(this).attr('data-readmore');
				var rltext = $(this).attr('data-readless');
				var _dh = $(this).find('div').css('max-height','none').height();
				
				if ( $('.container').hasClass('article-up') ) {
					$('.article-up .thumbnail .caption').each(function(){
						$(this).css('top',$(this).parent().find('img').height());
					});
					if ( _dh > 125 )
						$(this).addClass('rmc_'+i+'').append('<a onclick="readmore(\''+rmtext+'\',\''+rltext+'\',\'.rmc_'+i+'\',this);" class="readmore-link">'+rmtext+'</a>');
				} else {
					if ( _dh > 60 )
						$(this).addClass('rmc_'+i+'').append('<a onclick="readmore(\''+rmtext+'\',\''+rltext+'\',\'.rmc_'+i+'\',this);" class="readmore-link">'+rmtext+'</a>');
				}
				$(this).find('div').removeAttr('style');
			});
		}
	};

	// Scrollto yönü için data attr eklendi (alta, üste yasla) 
	$(document).on('click', '.scroll-to-element', function() {
		scrollToEl(this);
	});
	
	$(document).on('click', '.scroll-last-sibling', function() {
		scrollToEl($(this).siblings('[data-scroll-sibling]').last());
	});
	
	$(document).on('focus', '.scroll-to-element-focus', function() {
		scrollToEl(this);
	});
	
	$(document).on('click', '.scroll-to-parent-click', function() {
		scrollToEl($(this).parents('[data-scroll-parent]'));
	});
	
	$(document).on('click', '.scroll-mobile-to-parent-click', function() {
		if(window.isPhone)
			scrollToEl($(this).parents('[data-scroll-parent]'));
	});
	
	$(document).on('focus', '.scroll-mobile-to-parent-focus', function() {
		if(window.isPhone)
			scrollToEl($(this).parents('[data-scroll-parent]'));
	});
	
	var isScrollActive = false;
	window.scrollToEl = function(el, targetG, offset, dir, delay, duration, scrollEl, withNavHeight, completeFunction){
		
		if(isScrollActive || !el){
			return;
		}
		
		isScrollActive = true;
		delay = delay || $(el).data("scrolldelay") || 200;
		
		setTimeout(function() {
			var elm = $(el),
				target = $(elm.data('scrolltarget') || targetG || elm),
				scrollOffset,
				scrollTo, 
				isVisible = true,

				hasShownModal = $('.modal.in').length > 0;
			
			if(!target.length)
				target = elm;
			
			if(elm.data('scrolloffset') !== undefined) {
				scrollOffset = elm.data('scrolloffset');

			} else {
				// default 100 idi.
				scrollOffset = offset && offset.toString() !== "" ? offset : 0;
			}
			
			var scrollDir = elm.data('scrolldir') || dir || 'top';
				duration = elm.data('scrollduration') || duration || 500;
				scrollEl = elm.data('scrollEl') || scrollEl || $('body, html');

			if(hasShownModal) {
				scrollEl = $(scrollEl).find('.modal.in');
			}
			
			var top = 0;
			
			if (hasShownModal) {
				top = (scrollEl.length && target.length) ? target.offset().top - scrollEl.offset().top + scrollEl.scrollTop() : (target.length) ? target.offset().top : 0;
			} else{
				top = (target.length) ? target.offset().top : 0;
			}
			
			function windowHeight(normal){
				return normal ? parseInt($(window).height()) : parseInt($(window).height() - fixNavHeight());
			}

			function fixNavHeight() {
				if(!withNavHeight) {
					var msMenu = $("nav.navber-lower");
					var issubMenuAffix = 0;
					msMenu.length > 0 ? (issubMenuAffix = msMenu.hasClass("affix") ? parseInt(msMenu.outerHeight()) : 0) : 0;
					var navbarHeight = $("header .navbar").length ? parseInt($("header .navbar").height()) : 0; 
					return navbarHeight + issubMenuAffix;
				} else {
					return 0;
				}
			}
			
			function targetHeight() {
				return target.is(":visible") ? parseInt(target.outerHeight()) : 0;
			}
			
			var h, bottom, windowScrollBoxHeight;

			if (scrollDir === 'bottom') {
				scrollOffset = scrollOffset === 100 ? 10 : scrollOffset;

				h =  windowHeight(true) - targetHeight();
				bottom = top - h;
				
				scrollTo = bottom + scrollOffset;

				var targetBoxHeight = top + targetHeight();
				windowScrollBoxHeight = windowHeight(true) + $(window).scrollTop();
				
				if( targetBoxHeight >= windowScrollBoxHeight ) {
					isVisible = false;
				}
			} else if(scrollDir === "centerBottom"){
				scrollOffset = scrollOffset === 100 ? 10 : scrollOffset;

				if ( targetHeight() < windowHeight() ) { // Ortalama
					scrollTo = top - (windowHeight() / 2) + (targetHeight() / 2) - fixNavHeight();
				} else { // Alta yapıştırma
					h =  windowHeight(true) - targetHeight();
					bottom = top - h;
					scrollTo = bottom + scrollOffset;
				}
				isVisible = false;
			} else if(scrollDir === "top?"){
				scrollTo = top - scrollOffset - fixNavHeight();
				windowScrollBoxHeight = $(window).scrollTop();
				
				if( scrollTo > 0 && scrollTo < windowScrollBoxHeight ) {
					isVisible = false;
				}
			} 
			/*else if(hasScrollOffset){
				isVisible = false;
				scrollTo = scrollOffset + fixNavHeight();
			} */
			else {
				isVisible = false;

				if($(target).css('margin-top')) {
					var margin = $(target).css('margin-top').replace('px','');
					scrollTo = top - scrollOffset - fixNavHeight() - parseInt(margin);
				} else {
					scrollTo = top - scrollOffset - fixNavHeight();
				}
			}
			var defaultCompleteFunction = function(){scrollEl.stop();};
			completeFunction = completeFunction || defaultCompleteFunction;
				
			if (!isVisible) {
				scrollEl.stop(0).animate({
					scrollTop: scrollTo,
					duration: duration,
					always: completeFunction
				});
			}

			isScrollActive = false;
		},delay);
	}

	$(document).on('click', '.car-rental-scroll tr.car-rental-scroll-row', function(){
		var that = this;
		setTimeout(function () {
			if ( $(that).next().is(":visible") )
				scrollToEl($(".car-rental-scroll tr:visible .btn-danger").parent(), undefined, undefined, "bottom");
		}, 410);
	});
	
	function setDeviceTypeByWidth() {
		var wWidth = $(window).width();
		
		window.isMobile = (wWidth < 992);
		
		window.isDesktop = (wWidth >= 992);
		window.isTablet = (wWidth < 992) && (wWidth >= 768);
		window.isPhone = (wWidth < 768);
		window.isPhoneOrTablet = (wWidth < 992);
		
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
		if( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) ) {
			window.isIOS = true;
		} else if( userAgent.match( /Android/i ) ) {
			window.isAndroid = true;
		}
	}

	$(document).ready(function() {
		$(document).trigger('contentReady');
		window.willReloadAfterLogin = $('#schedule').length > 0;
		setDeviceTypeByWidth();

		sectionBg();
		$(".forLetsBegin").parent().addClass("relative");
		if ( $('#scrollhere').length > 0 ) {
			$('html, body').animate({scrollTop: $('#scrollhere').offset().top - 50}, 1000);
		}
		if (window.self != window.top) {
			$('.carousel').carousel('pause');
		}
		
		$(':text, textarea').placeholder();
		
		$('[data-bs-toggle="tooltip"]').tooltip();
		

		
		$(document).delegate('.radio input:radio','focus',function(){
			$(this).next().addClass('customfocus');
		});
		
		$(document).delegate('.radio input:radio','focusout',function(){
			$(this).next().removeClass('customfocus');
		});


		$(document).on('click', function(event) {
			if(!$(event.target).closest('.port-select-wrapper').length) { //general booker list close when click out
				$('.port-select-wrapper').removeClass('focused');
			}
			
			if(!$(event.target).closest('.navbar-nav.loginned .loginned').length) {
				$('.navbar-nav.loginned .loginned .opened').removeClass('opened');
			}
			
			if (!$(event.target).next().is('.empty-selectpicker') && $('.empty-selectpicker').siblings('select').children('optgroup').length > 0) {
				$('.empty-selectpicker').removeClass('empty-selectpicker');
			}
		});
		
		//for signupMS btn to trigger header-ms-singup btn
        $(document).on('click', '#signupMS', function() {
        	var href = $('.thyHeaderLink.header-ms-singup').attr('href');
        	if(href)
        		window.location = href;
        });
		
        var showSelectValidation = function(that, required) {
			if(required && that.hasClass('select-loaded')) {
				var dataId = that.attr('id');
				that.parent().addClass('has-error has-feedback');
				if(!that.parent().find('[role="alert"]').length) {
					var dataErrorText = i18n.get("ERR-MS-LOGIN-380");
					var errorHtml = '<p class="mt-3" role="alert" id="error' + dataId + '" for="' + dataId + '"><small><i aria-hidden="true" class="fa fa-warning red"></i> <span id="errormessage">' + dataErrorText + '</span></small></p>'
					that.parent().append(errorHtml);
				} else {
					that.parent().find('[role="alert"]').show();
				}
			} else {
				that.addClass('select-loaded');
			}
		}
        
        var hideSelectValidation = function(that) {
			that.parent().removeClass('has-error has-feedback').find('.has-error').removeClass('has-error has-feedback');
			that.parent().find('[role="alert"]').hide();
        }
        
		$(document).on('change', '.passengerDetailPanelCmp select[data-validation]', function() {
			var that = $(this), inputValue = '', thatValue = '';
			var required = JSON.parse(that.attr('data-validation')).required;
			setTimeout( function() {
				thatValue = that.val();
				if(that.hasClass('with-input')) {
					inputValue = that.parents('.tk-input-field').find('input.form-control').val();
					required = required ?
							required : inputValue.length ?
									(thatValue.length ? false : true) : (thatValue.length ? true : false);
					if(inputValue.length) {
						if(thatValue.length) {
							hideSelectValidation(that);
						} else {
							showSelectValidation(that, required);
						}
					} else if(required) {
						showSelectValidation(that, required);
					} else {
						hideSelectValidation(that);
					}
				} else {
					if(thatValue.length) {
						hideSelectValidation(that);
					} else {
						showSelectValidation(that, required);
					}
				}
			}, 10);
		});
		
        var backToTop = function () {
        	var scrollTrigger = 100;
        	var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
                $('.backtotop').addClass('opacity-0-5');
            } else {
                $('.backtotop').removeClass('opacity-0-5');
            }
        };
	    
        backToTop();
	    
	    $(window).on('scroll', function () {
	        backToTop();
	    });

		
		$('.backtotop').on('click',function(){
			$('html, body').animate({scrollTop: 0}, '2000');
		});
		
		if ( $('header .navbar div').hasClass('notice') ) {
			$('header .navbar .notice button').click(function(){
				var el = $(this).parent('.notice');
				el.slideUp('slow',function(){ el.remove(); });
			});
		}
		
		$('.nav-default li a').on('click', function(e){
			e.preventDefault();
			$('.nav-default li a i').removeClass('fa-chevron-up red').addClass('fa-chevron-down');
			if ( !$(this).parent().hasClass('active') && $(this).find('label').hasClass('metro-radio') ) {
				$(this).find('input').attr('checked','checked');
				$(this).find('i').removeClass('fa-chevron-down').addClass('fa-chevron-up red');
			}
			if ( $(this).parent().hasClass('active') && $(this).find('label').hasClass('metro-radio') ) {

				$($(this).attr('href')).removeClass('active');
				$(this).parent().removeClass('active');
				return false;
			}
		});
		
		//Collapse Next Content
		$('.collapse-next-content').on('click.collapse-next.data-api', '[data-bs-toggle=collapse-next]', function() {
			var $target = $(this).next();
			$target.collapse('toggle');
			if ( $(this).find('td') ) {
				$(this).parent().parent().hasClass('collapse-next-content-active') ? $(this).parent().parent().removeClass('collapse-next-content-active') : $(this).parent().parent().addClass('collapse-next-content-active');
			} else {
				$(this).parent().hasClass('collapse-next-content-active') ? $(this).parent().removeClass('collapse-next-content-active') : $(this).parent().addClass('collapse-next-content-active');
			}
		});
		// End
		
		// Top Navigation Language Section
		if($('.dropdownselect').length)
			$('.dropdownselect').selectpicker();
		
		$('.language-container .dropdown-menu .dropdownselect').click(function(){
			return false;
		});
		$('.language-container .dropdown-menu .dropdownselect button').click(function(){
			if ( $(this).next().css('display') === 'none' ) {
				$(this).next().show();
			} else if ( $(this).next().css('display') === 'block' && $(this).next().hasClass('open') ) {
				$(this).next().removeClass('open');
			} else {
				$(this).next().addClass('open');
			}
		});
		$('.language-container .dropdown-menu .dropdownselect .dropdown-menu.open').click(function(){
			$(this).removeClass('open');
		});
		$('.language-container form').click(function(){
			var _a = $('.language-container .dropdown-menu .dropdownselect .dropdown-menu');
			if ( _a.css('display') == 'block' && _a.hasClass('open') ) {
				_a.removeClass('open');
			}
		});
		
		$('.signin-container .dropdown-menu .dropdownselect').on('click', function(){
			return false;
		});
		$('.signin-container .dropdown-menu .dropdownselect button').on('click', function(){
			if ( $(this).next().css('display') == 'none' ) {
				$(this).next().show();
			} else if ( $(this).next().css('display') == 'block' && $(this).next().hasClass('open') ) {
				$(this).next().removeClass('open');
			} else {
				$(this).next().addClass('open');
			}
		});
		$('.signin-container .dropdown-menu .dropdownselect .dropdown-menu.open').on('click', function(){
			$(this).removeClass('open');
		});
		$('.signin-container form').on('click', function(){
			var _a = $('.signin-container .dropdown-menu .dropdownselect .dropdown-menu');
			if ( _a.css('display') === 'block' && _a.hasClass('open') ) {
				_a.removeClass('open');
			}
		});
		// End
		
		// Detect Anchor Tag Link
		$('a[href*=#]:not([href=#])').click(function() {
			if ( $(this).hasClass('taglink') && location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname ) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				var _h = 60;
				if ( $('.subnav').length > 0 ) {
					_h = 120;
				}
				if (target.length) {
					if(window.isPhoneOrTablet && target.hasClass('hidden-xs') && target.next().hasClass('visible-xs')) {
						target = target.next();
					}
					$('html,body').animate({scrollTop: target.offset().top - _h}, 500);
					return false;
				}
			}
		});
		// End
		
		// Footer Changed Collapse Menu for Mobile
		if ( findBootstrapEnvironment() == 'xs' ) {
			$('footer nav, .mobile-collapse-content').on('click.collapse-next.data-api', '[data-bs-toggle=collapse-next]', function() {
				var $target = $(this).next();
				$target.collapse('toggle');
			});
		}
		// End
				
		// Subnav
		if ( findBootstrapEnvironment() === 'xs' && $('.subnav') ) {
			$('.subnav').each(function(){
				$(this).find('.subnav-brand').text($(this).find('.navbar-nav li a.active').text());
			});
		}
		// End
		
		// TourIstanbul
		$('.touristanbul-time a').on('click', function(){
			$('.touristanbul-time a').removeClass('selected');
			$(this).addClass('selected');
			var tiid = $(this).attr('data-id');
			$('.ti-days').addClass('d-none');
			$('#'+tiid+'').removeClass('d-none');
			$('#'+tiid+' .touristanbul-days li:first-child a').click();
		});
		$('.touristanbul-days a').on('click', function(){
			$('.touristanbul-days a').removeClass('selected');
			$(this).addClass('selected');
			var tidayid = $(this).attr('data-id');
			$('.tourday').addClass('d-none');
			$('#'+tidayid+'').removeClass('d-none');
		});
		// End
		
		var setTimeoutcontrol;
		var setTimeoutcontrol2;
		var setTimeoutcontrol3;
		var contentheightAndSectionBG=function(){
	    	setTimeout('$(".forLetsBegin").parent().removeClass("relative");', 500);
			clearTimeout(setTimeoutcontrol);
			setTimeoutcontrol = setTimeout('contentheight()', 500);
			clearTimeout(setTimeoutcontrol2);
			setTimeoutcontrol2 = setTimeout( function(){ sectionBg();}, 500 );
			clearTimeout(setTimeoutcontrol3);
			setTimeoutcontrol3 = setTimeout('$(".forLetsBegin").parent().addClass("relative");', 500);
		};
		
		// IE8 Fix
		if ( browser.isIE && browser.version < 9 ) {
			$('.metro-checkbox input').click(function(){
				if ( $(this).is(':checked') ) {
					$(this).parent().addClass('checked');
				} else {
					$(this).parent().removeClass('checked');
				}
			});
		} else {
			$(window).resize(function(){
				contentheightAndSectionBG();
			});
			$(document).on('contentReady',function(){
				contentheightAndSectionBG();
			});
		}
		// End
		
		// IE Fix
		if ( browser.version <= 11 || browser.isIE) {
			$('html').addClass('ie');
		}
		// End
		
		
		$('.carousel').each(function(){
			if ( $(this).find('article').length > 0 ) {
				$(this).find('.item').each(function(i){
					if ( i !== 0 ) $(this).removeClass('active');
				});
			}
		});
		
		if ( $('.container').hasClass('article-collapse') ) {
			var _s = '';
			
			$('.article-collapse .thumbnail .caption').each(function(){
				$(this).css('top',$(this).parent().find('img').height());
			});
			
			$('.article-collapse .thumbnail .caption div a').on('click', function(){
				if ( $(this).parent().parent().attr('style') ) {
					_s = $(this).parent().parent().attr('style');
					$(this).parent().parent().removeAttr('style').addClass('caption-overflow');
				} else {
					$(this).parent().parent().attr('style',_s).removeClass('caption-overflow');
				}
			});
		}
		// End
		
		// Custom Collapse
		$('.accordion').on('shown.bs.collapse hidden.bs.collapse', function(){
			$(this).find('.card').removeClass('panel-active');
			$(this).find('.card-header').find('.dot').removeClass('dot-select');
			$(this).find('.collapse').each(function(){
				if( $(this).hasClass('show') ) {
					$(this).parent().addClass('panel-active');
					$(this).prev().find('.dot').addClass('dot-select');
				}
			});
		});
		$('.accordion .card').on('click', function(){
			$('.accordion .card').removeClass('panel-active');
			if ( !$(this).hasClass('panel-active') )
				$(this).addClass('panel-active');
		});
		$('.custom-accordion').on('shown.bs.collapse', function(){
			$(this).find('.collapse').each(function(){
				if( $(this).hasClass('show') ) {
					$(this).prev().find('.fa-chevron-right').removeClass('fa-chevron-right').addClass('fa-chevron-down');
				} else {
					$(this).prev().find('.fa-chevron-down').removeClass('fa-chevron-down').addClass('fa-chevron-right');
				}
			});
		});
		$('.custom-accordion').on('hidden.bs.collapse', function(){
			$(this).find('.fa-chevron-down').removeClass('fa-chevron-down').addClass('fa-chevron-right');
		});


		$(window).on('shown.bs.modal', function() {
			noScrollFunc();
		});
		
		$(window).on('hidden.bs.modal', function() {
			window.milesInactiveModalOpen = false;
		});

		if(window.isIOSPhone) {
			$(document).on('shown.bs.modal', '#signinModal,#siginModalContainer', function () {
				$('body').addClass('ios-modal-opened');
			});
	
			$(document).on('hidden.bs.modal', '#signinModal,#siginModalContainer', function () {
				$('body').removeClass('ios-modal-opened');
			});
			
	        $(document).on('focus','.ios-modal-opened .modal input.form-control',function(e) {
	        	e.preventDefault();
	        });
		}
		
		// ScrollSpy
		$('.countrylistmodal').on('shown.bs.modal', function() {
			$('.country-list ul').scrollspy({target: '.country-alphabet', offset: 40});
		});
		// End
		
		$('.ourfleetcarousel a.carousel-control').on('click', function(){
			if ( $(this).hasClass('carousel-control-left') ) {
				$('.ourfleetcarousel').carousel('prev');
			}
			if ( $(this).hasClass('carousel-control-right') ) {
				$('.ourfleetcarousel').carousel('next');
			}
		});
		
		// Monthpicker
		$('.monthpicker input').keyup(function(){
			var _v = $(this).val();
			setTimeout(function(){
				if ( _v != null && _v > 0 ) {
					$('.monthpickerdropdown li a').each(function(){
						if ( $(this).attr('data-id') === _v ) {
							$('.monthpicker input').val($(this).text());
						}
					});
				}
			}, 1000);
			if ( _v != null && _v > 12 ) {
				$('.monthpicker input').val('');
			}
		});
		$('.monthpickerdropdown li a').on('click', function(){
			$('.monthpicker input').val($(this).text());
		});
		// End
		
		// Caret
		$('.caret-toggle').on('click', function(){
			var el = $(this).find('i');
			if ( el.hasClass('fa-caret-down') ) {
				el.removeClass('fa-caret-down').addClass('fa-caret-up');
			} else {
				el.removeClass('fa-caret-up').addClass('fa-caret-down');
			}
		});
		// End
		window.noScrollFunc = function(){
			$('.noScroll').closest('body.modal-open:not(body.modal-open.mobile-modal-open)').addClass('noScrollbody'); 
		}
		// chevron-toogle
		setTimeout(function(){
			$('.chevron-toggle').on('click', function(){
				var el = $(this).find('i');
				if ( el.hasClass('fa-chevron-down') ) {
					el.removeClass('fa-chevron-down').addClass('fa-chevron-up');
				} else {
					el.removeClass('fa-chevron-up').addClass('fa-chevron-down');
				}
			});
		},3500);
		// End

		$('.cs-toggle-panel-btn').on('click', function(){
		    $(".cs-toggle-panel-btn").toggleClass("filter-btn-open"); 
		});
		
		$(document).on('click','.wingo-share-btn', function(){
	        $(this).closest(".async-cms-block").addClass("z-index-inherit"); 
		});
		// End
		
		carouselIndicators();
		
		charlimit();
		
		// Fix Search Button Width
		function selectWidth() { 
			$(".car-rental .bootstrap-select-searchbox").width($(".bootstrap-select-searchbox").parent().prev().width()-10);
		}

		$(window).resize(function() {
			setDeviceTypeByWidth();
			setTimeout(function() { selectWidth(); }, 500);
		});
		
		$('textarea.extend_height').each(function () {
			$(this).attr('style', 'height:' + ($(this)[0].scrollHeight) + 'px;overflow-y:hidden;');
		}).on('keyup', function () {
			$(this).css({'height':'auto'});
			$(this).height($(this)[0].scrollHeight);
		});
		
		setTimeout(function() {
			$(window).resize();
		}, 500);
		
		if(window.isPhoneOrTablet) {
			var intCount = 0;
			var checkFixedButtonInterval = setInterval(function() {
				intCount++;
				if(intCount < 8 && $('.fixed-bottom-mbl').length) {
					$('body').css('padding-bottom', $('.fixed-bottom-mbl').outerHeight());
					clearInterval(checkFixedButtonInterval);
				} else if(intCount >= 8) {
					clearInterval(checkFixedButtonInterval);
				}
			}, 1000);
		}
		
		function headerHeightFunc() {
			var headerFixedHeight = $('body header .navbar-fixed-top .navbar-collapse-header').outerHeight(),
			mainMarginTop = $('#msMenu');
			if (window.isDesktop || window.isTablet) {
				if (headerFixedHeight > 61){
					mainMarginTop.css("margin-top",headerFixedHeight/2);
				} else {
					mainMarginTop.removeAttr("style");
				}
		    }
			else{
				mainMarginTop.removeAttr("style");
			}
		} 
		headerHeightFunc();

		require(['app/ko-app']);
		
		var lazy_loading = function() {
			var self = {};
			self.run_scroll_methods = function() {
				$(function(){ 
					$(window).scroll(function(){
						$('.async-cms-block').each(function(){ 
							if(isScrolledIntoView($(this)) && !$(this).data('active')){
								var content_url = $(this).data('content-url');
								var _this = $(this);
								$(_this).attr("data-active", "true");
								var carouselLoad = $('.carousel');
								var customMMPlayerLoad = $('.customMMPlayer');
								$.ajax({
									url:content_url,
									crossDomain: true,
									async: true,
									type: "GET",
									dataType: 'html',
									global : false,
                                    beforeSend : function(xhr, opts){
                                        opts.url = content_url;
                                    },
									success:function(result){
										try {
											$(_this).html(result);
											window.eval(result.fnc);
											self.run_scroll_methods();
											self.run_dom_ready_fnc();
											$(_this).removeAttr("style");
											if(!carouselLoad.length){
												carouselIndicators();

											}
											
											if(!customMMPlayerLoad.length){
												loadVideoAndStills();
											}
											sectionBg();
											//when a async block load, run article function for Read More button
		                                    article('article');
										} catch (e) {
											console.error("content_url: " + content_url + " - Error: " + e);
										}
									}
								});
							}
						}); 
					});
				});
			}; 
			self.run_dom_ready_fnc = function(){
				if(carouselIndicators){
					carouselIndicators();
				}
			}
			self.init = function() {
				self.run_scroll_methods(); 
				var windowHSize = $(window).height();
				$('.async-cms-block').height(windowHSize); 
				return self;
			}
			return self;
		}().init();
		
		$(function(){
			lazy_loading.run_dom_ready_fnc();
		});
	 });


	// perfect-scrollbar
	 $("ul#countryOptions li a ").click(function(){
			$(".cityairport-list").scrollTop(0);
	});
	 
	//flight list SCROLL
	$(document).on('click', '.canvas-table-wrapper:not(.not-scroll)', function(event) {
		var winH = $(window).height();
		var eTop = $(this).offset().top - $(window).scrollTop() + $(this).height();
		var boxPosition = $(this).offset().top - $(window).height()+ $(this).height();
		
		if (eTop > winH ){
			$("html, body").animate({ scrollTop: boxPosition }, "slow");
			return $(event.target).closest('a[href]').length > 0;
		}
	});	
	 
     
    //mobile sub navigation sticky menu toggle icon change.  	
	var subStickyNavBar=$(".navbar-toggle.subnav-toggle");
	var subStickyNavBarFa=$(".navbar-toggle.subnav-toggle .fa");
	subStickyNavBar.on( "click", function() {
		if(subStickyNavBar.hasClass("in")){
			subStickyNavBarFa.addClass("fa-chevron-up");
			subStickyNavBarFa.removeClass("fa-chevron-down");
		}else{
			subStickyNavBarFa.addClass("fa-chevron-down");
			subStickyNavBarFa.removeClass("fa-chevron-up");
		}
	});
	//any question header search button hide this page searchmain, faqtopic, faqdetail
	var namePage=i18n.getMetaDataAttribute("pagetype");
	if(namePage=='searchmain'||namePage=='faqtopic'||namePage=='faqdetail'){
		var elem = $('#FaqSearchBtn').length ? $('#FaqSearchBtn') : $('#FaqSeachBtn');
		elem.addClass('d-none');
		elem.parent().prev().addClass('d-none');

	}
  	
});

var getUrlVars = function(){
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
 };
 
if (!String.prototype.startsWith) {
	String.prototype.startsWith = function(search, pos) {
		return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
	};
}

String.prototype.turkishtoLatin = function () {
    return this.replace(/(ğ|Ğ)/g, 'g')
        .replace(/(ü|Ü)/g, 'u')
        .replace(/(ş|Ş)/g, 's')
        .replace(/(ı|İ)/g, 'i')
        .replace(/(ö|Ö)/g, 'o')
        .replace(/(ç|Ç)/g, 'c');
};
 
